import { endOfDay, startOfDay, subDays } from "date-fns";

/**
 * "Last 7 Days" on the athlete attendance pages: today and the six days
 * before it, whole days. Both pages computed "since Sunday" instead
 * (getDate() - getDay()), so on a Monday the range held two days and on a
 * Sunday one (2026-10-11).
 */
export function lastSevenDaysRange(now: Date = new Date()): [Date, Date] {
  return [startOfDay(subDays(now, 6)), endOfDay(now)];
}
